"use client";

import React from "react";

import Image from "next/image";
import { useTranslations } from "next-intl";

import nutritionCloudImg from "@/app/assets/illustration/6 formula/webp/adequate nutrition.webp";
import ageCloudImg from "@/app/assets/illustration/6 formula/webp/age appr wake windows.webp";
import emotCloudImg from "@/app/assets/illustration/6 formula/webp/emotional needs.webp";
import flaskImg from "@/app/assets/illustration/6 formula/webp/flask.webp";
import soothingCLoudImg from "@/app/assets/illustration/6 formula/webp/self soothing skills.webp";
import sleepSkillsCloudImg from "@/app/assets/illustration/6 formula/webp/sleep inducing env.webp";

import { CloudBreak } from "./cloudBreak";

type CloudVariant = "age" | "emotional" | "environment" | "nutrition" | "soothing";

const cloudImages = {
    age: ageCloudImg,
    emotional: emotCloudImg,
    environment: sleepSkillsCloudImg,
    nutrition: nutritionCloudImg,
    soothing: soothingCLoudImg,
} as const;

const FormulaSection = () => {
    const t = useTranslations("NewHome.formula");

    const textClasses = "text-xl text-black";

    const TextWithCloud = ({
        className = "",
        text,
        variant,
    }: {
        className?: string;
        text: string;
        variant: CloudVariant;
    }) => (
        <div>
            <div className={`relative inline-block px-6 pt-14 pb-8 ${className}`}>
                <Image alt="" className="absolute left-0 top-0 w-full h-full" src={cloudImages[variant]} />
                <div className={" " + textClasses}>{text}</div>
            </div>
        </div>
    );

    return (
        <section className="relative">
            <div className="container mx-auto px-4 py-16">
                {/* <h2 className="text-3xl md:text-4xl font-bold text-black text-center mb-16">{t("title")}</h2> */}
                <div className="relative lg:!pt-36 pt-4 max-w-4xl mx-auto">
                    {/* Mobile list view */}
                    <div className="lg:hidden space-y-4 text-center mb-12">
                        <TextWithCloud text={t("elements.wakeWindows")} variant="age" />
                        <TextWithCloud text={t("elements.nutrition")} variant="nutrition" />
                        <TextWithCloud text={t("elements.emotional")} variant="emotional" />
                        <TextWithCloud text={t("elements.selfSoothing")} variant="soothing" />
                        <TextWithCloud text={t("elements.environment")} variant="environment" />
                    </div>

                    <div className="relative aspect-square max-w-2xl mx-auto">
                        <Image
                            alt="Sleep formula flask"
                            className="object-contain"
                            fill
                            loading="lazy"
                            src={flaskImg}
                        />

                        {/* Desktop positioned elements */}
                        <div className="absolute inset-0 hidden lg:block">
                            <div className="absolute -top-10 left-1/2 -translate-x-1/2 -translate-y-32 text-center">
                                <TextWithCloud text={t("elements.wakeWindows")} variant="age" />
                            </div>

                            <div className="absolute top-40 left-0 -translate-x-1/2 text-right">
                                <TextWithCloud text={t("elements.emotional")} variant="emotional" />
                            </div>

                            <div className="absolute top-0 left-4 -translate-x-1/2 text-right">
                                <TextWithCloud text={t("elements.nutrition")} variant="nutrition" />
                            </div>

                            <div className="absolute top-1/4 right-0 translate-x-1/2 text-left">
                                <TextWithCloud text={t("elements.environment")} variant="environment" />
                            </div>

                            <div className="absolute top-0 left-1/2 translate-x-3/4 text-left">
                                <TextWithCloud text={t("elements.selfSoothing")} variant="soothing" />
                            </div>
                        </div>
                    </div>

                    {/* Decorative clouds */}
                    {/* <div className="absolute top-0 right-0 -translate-x-1/8 w-60 h-60">
                        <div className="animate-float-x-alt h-full">
                            <Image alt="" className="object-contain animate-float-y-alt" fill src={cloudImg} />
                        </div>
                    </div>
                    <div className="absolute top-1/2 left-0 -translate-x-1/4 -translate-y-1/4 w-60 h-60">
                        <div className="animate-float-y h-full">
                            <Image alt="" className="object-contain animate-float-x" fill src={cloudImg} />
                        </div>
                    </div> */}
                </div>
                {/* <CloudBreak /> */}
            </div>
        </section>
    );
};

export default FormulaSection;
